<template>
  <h3
    :class="
      `
        mb-3
        d-flex
        text-subtitle-1
        grey--text
        center-items
        text--darken-1
        font-weight-regular
        board__column-title${clean ? '--clean' : ''}
      `
    "
  >
    {{ $t(`status.${title}`) }}

    <v-chip v-if="!clean" class="ml-auto" color="grey lighten-1" small>
      <span class="grey--text text--darken-2 font-weight-bold">
        {{ total }}
      </span>
    </v-chip>

    <v-btn
      @click="setBoardPendingActions(false)"
      class="ml-auto"
      v-else
      small
      icon
    >
      <v-icon small>
        mdi-close
      </v-icon>
    </v-btn>
  </h3>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'BoardColumnTitle',

  props: {
    title: {
      type: String,
      required: true,
    },

    total: {
      type: String | Number,
    },

    clean: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapMutations(['setBoardPendingActions']),
  },
}
</script>
